import { render, staticRenderFns } from "./PrintPermissionDoc.vue?vue&type=template&id=23f492e3&scoped=true&"
import script from "./PrintPermissionDoc.vue?vue&type=script&lang=js&"
export * from "./PrintPermissionDoc.vue?vue&type=script&lang=js&"
import style0 from "./PrintPermissionDoc.vue?vue&type=style&index=0&id=23f492e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f492e3",
  null
  
)

export default component.exports